
import React, { useState, useEffect, memo } from "react";


import { getUser } from "../../Model/LocalStorage";
import { auctionsLive } from "../../Model/Auction";
import GridLayout from "./gridLayout";



import { hostname } from "../../../config";
import useMediaQuery from "@mui/material/useMediaQuery";

const socket = hostname;
// const socket = io.connect("http://localhost:3005");

function View(props) {
  const status = true;
  const matchesPhone = useMediaQuery("(min-width:700px)");
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = useState("");
  const [getData, setGetData] = useState([]);
  const [room, setRoom] = useState("");
  const [type, setType] = useState("");
  const [username, setUsername] = useState("");
  const LiveAuction = () => {
    setLoading(true);
    try {
      async function getAuctionOne() {
        const results = await auctionsLive();
        // console.log("live auction")
        if (results.success === false) {
          setMessage(results.msg);
          setOnline(!isOnline);
        } else {
          setGetData(results);
          setRoom(results.auction_details.auction_id);
          socket.emit("joint_room", results.auction_details.auction_id);
        }
        // setGetData(results);
        setLoading(false);
      }
      getAuctionOne().catch(console.error);
    } catch (error) {}

    fetch(`http://157.230.43.47:3005/type`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // alert(data.isDesktop)
        setType(data.isMobile);
      })
      .catch((error) => {
        console.log("error ", error);
      });
  };

  const [isOnline, setOnline] = useState(true);
  const updateNetworkStatus = () => {
    setOnline(navigator.onLine);
    setMessage("Network Error!...");
  };

  useEffect(() => {
    //  return () =>  socket.removeAllListeners();
    window.addEventListener("load", updateNetworkStatus);
    window.addEventListener("online", updateNetworkStatus);
    window.addEventListener("offline", updateNetworkStatus);

    return () => {
      window.removeEventListener("load", updateNetworkStatus);
      window.removeEventListener("online", updateNetworkStatus);
      window.removeEventListener("offline", updateNetworkStatus);
      // window.addEventListener("click",onDisconnect)
    };
  }, [navigator.onLine, socket]);

  const [userID, setUserID] = useState("");
  useEffect(() => {
    try {
      LiveAuction();
      // console.log("socket   ",socket.connected)
    } catch (error) {
      // console.log("socket error   ",socket)
    }

    async function getUserList() {
      const getuser = await getUser();
      setUserID(getuser.id);
      setUsername(getuser.email);
      socket.emit("ConnectedUser", {
        userId: getuser.id,
        email: getuser.email,
      });
    }

    // console.log("socket.connected : ",socket.connected)
    getUserList().catch(console.error);
    // if (socket.connected) {
    //   console.log('connect');
    //    socket.connect();
    //  } else {
    //    console.log('disconnect');
    //    alert('Socket is disconnected.');
    //  }
    // function onDisconnect() {
    //   if (socket.connected) {
    //     console.log('connect');
    //      socket.connect();
    //    } else {
    //      console.log('disconnect');
    //      alert('Socket is disconnected.');
    //    }
    // }
  }, [hostname]);

  const [open, setOpen] = React.useState(true);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(!open);
  };

  return (
    <div style={{height:"100%"}}>
    
        {status === true ? (
          <>
          
            <GridLayout
              LiveData={getData}
              Socket={socket}
              Type={type}
              mediadQuery={props.mediadQuery}
            />
          </>
        ) : (
         <h1>No EVENT</h1>
        )}


    </div>
  );
}

export default View;
